module.exports = __webpack_public_path__ + "static/media/whole_class.19e5ec81.png";